/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InviteLinkRequest
 */
export interface InviteLinkRequest {
    /**
     * Token from a new-user invite link.
     * @type {string}
     * @memberof InviteLinkRequest
     */
    inviteToken: string;
}

/**
 * Check if a given object implements the InviteLinkRequest interface.
 */
export function instanceOfInviteLinkRequest(value: object): value is InviteLinkRequest {
    if (!('inviteToken' in value) || value['inviteToken'] === undefined) return false;
    return true;
}

export function InviteLinkRequestFromJSON(json: any): InviteLinkRequest {
    return InviteLinkRequestFromJSONTyped(json, false);
}

export function InviteLinkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InviteLinkRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'inviteToken': json['invite_token'],
    };
}

export function InviteLinkRequestToJSON(json: any): InviteLinkRequest {
    return InviteLinkRequestToJSONTyped(json, false);
}

export function InviteLinkRequestToJSONTyped(value?: InviteLinkRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invite_token': value['inviteToken'],
    };
}

